<template>
	<div>
		<alert :conditional="user.fb_page_id === null && user.organization.is_mandatoaberto !== 0"
			   :classFather="'alert'"
			   :message="'alert-facebook'"
			   :iconClass="'icon fas fa-warning'"
			   :linkShow="true"
			   :linkTo="'/perfil'"
			   :linkText="'configure'"
			   :altLink="'configure-facebook'"
			   :close-button="true">
		</alert>
		<section class="content__custom">
			<div class="main-title">
				<h1 class="integrations">
					{{ 'integrations' | translate | titleCase }}
				</h1>
			</div>
			<div class="boxes">
				<div class="box box--half">
					<votolegal></votolegal>
				</div>
				<div class="box box--half">
					<picframe></picframe>
				</div>
				<!-- <div class="box box--half">
					<twitter></twitter>
				</div> -->
			</div>

		</section>


	</div>
</template>
<script>
	import alert from '../../components/alert/alert.vue';
	import picframe from './picframe.vue';
	import twitter from './twitter.vue';
	import votolegal from './votoLegal.vue';

	export default {
		name: 'integrations',
		data() {
			return {
				integrationForm: {
					success: false,
				},
				integration: {
					email: '',
					greeting: '',
				},
				erro: false,
			};
		},
		components: {
			alert,
			picframe,
			twitter,
			votolegal,
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/integrations/integrations.vue